import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  formatQueryParams,
  JsonApiResponseDto,
  parseJsonApiResponse,
  prepareHeaders,
  Response,
  TQueryParams,
} from 'evolve-ui';

export type TMedicalProvider = {
  id: string;
  name: string;
  active: number;
};

export const medicalProvidersApi = createApi({
  reducerPath: 'medicalProviders',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.GATSBY_PROVIDERS_API_URL,
    mode: 'cors',
    prepareHeaders,
  }),
  tagTypes: ['providers'],
  endpoints: (builder) => ({
    getMedicalProviders: builder.query<
      Response<TMedicalProvider>,
      TQueryParams
    >({
      providesTags: ['providers'],
      query: (params) => formatQueryParams(params),
      transformResponse: (res, meta, args) => {
        return parseJsonApiResponse<TMedicalProvider>(
          res as JsonApiResponseDto<TMedicalProvider>,
          meta,
          args,
          true,
        );
      },
    }),
  }),
});

export const { useGetMedicalProvidersQuery } = medicalProvidersApi;
